<template>
  <div class="about">

    <div class="p-2 ml-2 bg-light gothic fontSizeDot9 border-top border-bottom">
      <router-link :to="{ name: 'tinkHome' }" custom v-slot="{ navigate }">
        <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
          처음
        </span>  
      </router-link>
      &gt;
      <b-dropdown text="서비스 소개" size="sm" role="menu" toggle-class="pl-2 pr-2 pt-dot1 pb-dot1">
        <b-dropdown-item :to="{ name: 'tinkAbout' }" :active="true">
          Tinkable 소개
        </b-dropdown-item>
        <b-dropdown-item :to="{ name: 'tinkAboutKit' }">
          IoT 키트
        </b-dropdown-item>
        <b-dropdown-item :to="{ name: 'tinkAboutCore' }">
          Core 프로그램
        </b-dropdown-item>
        <b-dropdown-item :to="{ name: 'tinkAboutData' }">
          Data 서비스
        </b-dropdown-item>
        <b-dropdown-item :to="{ name: 'tinkTos' }">
          서비스 약관
        </b-dropdown-item>
        <b-dropdown-item :to="{ name: 'tinkPrivacy' }">
          개인정보 처리방침
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <h1 class="documentTitle" v-if="!presentationMode">
      Tinkable 소개
    </h1>

    <div class="contentBody">
      <h2><a name="kit">Tinkable 개요</a></h2>
      <p class="extra">최초 버전의 이미지.</p>
      <p>Tinkable에 대한 간략한 소개.</p>
      <h2><a name="kit">Tinkable 구성</a></h2>
      <p class="extra">관련 사이트로 링크</p>
      <p>Tinkable IoT 키트, Tinkable IoT Core 프로그램, Tinkable IoT 데이터 서비스에 대한 개괄적인 소개.</p>
      <ul>
        <li>
          <router-link :to="{ name: 'tinkAboutKit' }" custom v-slot="{ navigate }">
            <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
              Tinkable IoT 키트
            </span>  
          </router-link>
          :
        </li>
        <li>
          <router-link :to="{ name: 'tinkAboutCore' }" custom v-slot="{ navigate }">
            <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
              Tinkable Core 프로그램
            </span>  
          </router-link>
          :
        </li>
        <li>
          <router-link :to="{ name: 'tinkAboutCore' }" custom v-slot="{ navigate }">
            <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
              Tinkable Data 서비스
            </span>  
          </router-link>
          :
        </li>
      </ul>
      <h2><a name="kit">Tinkable 역사</a></h2>
      <p class="extra">교육 사진들</p>
      <p>Tinkable IoT 키트, Tinkable IoT Core 프로그램, Tinkable IoT 데이터 서비스에 대한 개괄적인 소개.</p>
      <h2><a name="kit">Tinkable 고객</a></h2>
      <p>Tinkable IoT 키트, Tinkable IoT Core 프로그램, Tinkable IoT 데이터 서비스에 대한 개괄적인 소개.</p>
    </div>
  </div> 
</template>
<script>
  import { mapState } from "vuex"
  import { mapSetter } from "@/plugins/vuexUtils.js"
  export default {
    name: "tinkAbout",
    computed: {
      ...mapSetter(
        mapState({
          presentationMode:  state => state.presentationMode,
        })
      )
    },
    mounted() {
      window.document.body.scrollIntoView(true);
    },
  }
</script>
